import { createSelector } from "reselect";
const _selectCompany = state => state.company;

export  const  selectCompaniesCollection = createSelector(
    [_selectCompany],
    company => company.companiesList
)


export  const  selectIsCompaniesCollectionFetching = createSelector(
    [_selectCompany],
    company => company.isFetching
)
export  const  selectIsSelectedCompanyDetailsFetching = createSelector(
    [_selectCompany],
    company => company.isDetailsFetching
)
export const selectedCompany = createSelector(
    [_selectCompany],
    company => company.selectedCompany   
)

